export default function handleFollowHashtag(params) {
  const action = "followHashtag";

  const redirectTenantId = params.get("redirectTenantId");
  const messageIdRaw = params.get("messageId") || "";
  const tenantNameRaw = params.get("tenantName") || "";
  const emailIdRaw = params.get("emailId") || "";

  let tenantName = "";
  let emailId = "";

  // tenantName decode (new Base64 + old fallback)
  try {
    tenantName = tenantNameRaw
      ? decodeURIComponent(atob(tenantNameRaw))
      : "";
  } catch (e) {
    tenantName = decodeURIComponent(
      tenantNameRaw.replace(/\+/g, " ")
    );
  }

  // email decode (new Base64 + old fallback)
  try {
    emailId = emailIdRaw
      ? decodeURIComponent(atob(emailIdRaw))
      : "";
  } catch (e) {
    emailId = decodeURIComponent(emailIdRaw);
  }

  return {
    action,
    redirectTenantId: redirectTenantId
      ? Number(String(redirectTenantId).replace(/,/g, ""))
      : null,

    messageId: messageIdRaw
      ? Number(String(messageIdRaw).replace(/,/g, ""))
      : null,

    tenantName,
    emailId,
  };
}